import * as React from "react";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const useStyles = makeStyles({
  listbox: {
    maxHeight: "150px !important",
    overflowY: "scroll",
  },
});

export default function DropDown({
  placeHolder,
  viewHeight,
  borderRadius,
  bgColor,
  border,
  viewWidth,
  data,
  handleSelected,
  value,
  setSelectedId,
  borderColor,
  ...props
}) {
  const classes = useStyles();

  return (
    <Autocomplete
      {...props}
      disablePortal
      id="combo-box-demo"
      options={data}
      value={value}
      getOptionLabel={(option) => option.name || ""}
      onChange={handleSelected}
      classes={{
        listbox: classes.listbox,
      }}
      ListboxProps={{
        sx: { fontSize: 13 },
      }}
      sx={{
        width: viewWidth ? viewWidth : 150,
        backgroundColor: bgColor,
        color: "black",
        borderRadius: borderRadius,
        height: viewHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: border ? border : "0px",
        padding: "0 !important",

        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
          fontSize: 13,
        },
      }}
      renderInput={(params) => (
        <TextField
          sx={{ fontSize: 5, color: "red" }}
          {...params}
          placeholder={placeHolder}
        />
      )}
    />
  );
}
